import { render, staticRenderFns } from "./UserAccountList.vue?vue&type=template&id=2dc10f67&"
import script from "./UserAccountList.vue?vue&type=script&lang=ts&"
export * from "./UserAccountList.vue?vue&type=script&lang=ts&"
import style0 from "./UserAccountList.vue?vue&type=style&index=0&id=2dc10f67&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports